<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <Live2d/>
      <router-view/>
    </div>
  </a-config-provider>
</template>

<script>
import Live2d from '@/components/Live2d/index'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { deviceEnquire, DEVICE_TYPE } from '@/utils/device'
import { brand,defaultBrand } from '@/config/brand.config'
export default {
  data () {
    return {
      locale: zhCN,
    }
  },
  components: {
    Live2d
  },
  mounted () {
    const { $store } = this
    deviceEnquire(deviceType => {
      switch (deviceType) {
        case DEVICE_TYPE.DESKTOP:
          $store.commit('TOGGLE_DEVICE', 'desktop')
          $store.dispatch('setSidebar', true)
          break
        case DEVICE_TYPE.TABLET:
          $store.commit('TOGGLE_DEVICE', 'tablet')
          $store.dispatch('setSidebar', false)
          break
        case DEVICE_TYPE.MOBILE:
        default:
          $store.commit('TOGGLE_DEVICE', 'mobile')
          $store.dispatch('setSidebar', true)
          break
      }
    })
    const domain = window.location.host
    const customBrand = brand.find(item=>{
      return item.domain.includes(domain)
    })
    $store.dispatch('brandSetBrand', customBrand?customBrand:defaultBrand)
  },
  methods:{
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    }
  }
}
</script>
<style>
  #app {
    height: 100%;
  }
</style>
